<template>
  <div>
    v<span class="px-2">{{ version }}</span>
  </div>
</template>

<script>
  import { VERSION } from '@/config'

  export default {
    data: function () {
      return {
        version: VERSION
      }
    }
  }
</script>

<style scoped>
  div {
    font-size: var(--fs-xs);
    color: #333;
    text-align: right;
  }

  div span {
    font-size: var(--fs-xs);
  }
</style>
